import type { TCreditFormCommonFields } from '../../types';

export const prepareFormDataForCustomerUpdate = <T extends Partial<TCreditFormCommonFields>>(
  formData: T,
  shouldIncludeSelectedProductType: boolean,
): T | Omit<T, 'selectedProductType'> => {
  if (shouldIncludeSelectedProductType) {
    return formData;
  }

  const { selectedProductType: _, ...formDataWithoutSelectedProductType } = formData;

  return formDataWithoutSelectedProductType;
};
